import React, { useState } from "react";
import { Card, Grid, TextField, Button, Box, Typography } from "@mui/material";
import { useDispatch } from "react-redux";
import moment from "moment";

function Sidebar({
  setSearchparams,
  setPaginationModel,
  clientId,
  setClientId,
}) {
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  const [filterBy, setFilterBy] = useState("");
  const [clients, setClients] = useState("true");
  const [filterValue, setFilterValue] = useState("");
  const [error, setError] = useState({
    filterValue: "",
  });

  const handleSearch = () => {
    let hasError = false;
    let newError = {
      filterValue: "",
    };

    if (filterBy && !filterValue.trim()) {
      newError.filterValue = "Please enter a filter value.";
      hasError = true;
    }

    // if (!fromDate && !toDate) {
    //   newError.filterValue = "Please enter a date range.";
    //   hasError = true;
    // }

    if (hasError) {
      setError(newError);
      return;
    }

    setError({
      filterValue: "",
    });

    const params = {
      from: fromDate
        ? moment.utc(fromDate).startOf("day").format("YYYY-MM-DD[T]HH:mm:ss[Z]")
        : null,
      to: toDate
        ? moment.utc(toDate).endOf("day").format("YYYY-MM-DD[T]HH:mm:ss[Z]")
        : null,
      filter_by: filterBy !== "active" ? filterBy : null,
      filter: filterValue.trim() || null,
      is_verified: clients,
    };

    const cleanParams = Object.fromEntries(
      Object.entries(params).filter(([_, value]) => value != null)
    );

    setSearchparams(cleanParams);
    setPaginationModel({
      page: 0,
      pageSize: 10,
    });
    setClientId(clients === "true" ? true : false);
  };

  const handleReset = () => {
    setFromDate(null);
    setToDate(null);
    setFilterBy("");
    setFilterValue("");
    setError({ filterValue: "" });
    setSearchparams({});
    setClients("true");
    setClientId(true);
    setPaginationModel({
      page: 0,
      pageSize: 10,
    });
  };

  return (
    <Card sx={{ p: 3, mb: 2 }} elevation={4}>
      <Grid container direction="column" spacing={2}>
        {/* <Grid item>
          <TextField
            select
            label="Clients"
            fullWidth
            value={clients}
            onChange={(e) => {
              setClients(e.target.value);
            }}
            SelectProps={{ native: true }}
            InputLabelProps={{ shrink: true }}
          >
            <option value="true">Verified Clients</option>
            <option value="false">Prospective Clients</option>
          </TextField>
        </Grid> */}
        <Grid item>
          <TextField
            select
            label="Filter By"
            fullWidth
            value={filterBy}
            onChange={(e) => {
              setFilterBy(e.target.value);
              setFilterValue("");
              setFromDate(null);
              setToDate(null);
            }}
            SelectProps={{ native: true }}
            InputLabelProps={{ shrink: true }}
          >
            <option value="" disabled>
              Select
            </option>{" "}
            <option value="organization_name">Organization/Group</option>
            <option value="mobile_number">Mobile</option>
            <option value="email">Email</option>
          </TextField>
        </Grid>

        <Grid item>
          <TextField
            fullWidth
            label="Filter Value"
            variant="outlined"
            value={filterValue}
            onChange={(e) => setFilterValue(e.target.value)}
            error={!!error.filterValue}
            disabled={!filterBy}
          />
          {error.filterValue && (
            <Typography color="error" variant="body2">
              {error.filterValue}
            </Typography>
          )}
        </Grid>

        <Grid item>
          <Box sx={{ display: "flex", flexDirection: "column", width: "100%" }}>
            <TextField
              id="outlined-basic"
              value={fromDate ? moment(fromDate).format("YYYY-MM-DD") : ""}
              onChange={(e) => setFromDate(e.target.value)}
              label="From Date"
              variant="outlined"
              type="date"
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Box>
        </Grid>

        <Grid item>
          <Box sx={{ display: "flex", flexDirection: "column", width: "100%" }}>
            <TextField
              id="outlined-basic"
              value={toDate ? moment(toDate).format("YYYY-MM-DD") : ""}
              onChange={(e) => setToDate(e.target.value)}
              label="To Date"
              variant="outlined"
              type="date"
              inputProps={{
                min: fromDate ? moment(fromDate).format("YYYY-MM-DD") : "",
              }}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Box>
        </Grid>

        <Grid item>
          <Button
            variant="contained"
            fullWidth
            onClick={handleSearch}
            sx={{
              height: "100%",
              background: "linear-gradient(45deg, #ff4b2b 30%, #ff416c 90%)",
              color: "#fff",
              borderRadius: "8px",
              boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.2)",
              textTransform: "uppercase",
              fontWeight: "bold",
              "&:hover": {
                background: "linear-gradient(45deg, #ff416c 30%, #ff4b2b 90%)",
                boxShadow: "0px 6px 16px rgba(0, 0, 0, 0.3)",
              },
            }}
          >
            Search
          </Button>
        </Grid>

        <Grid item>
          <Button variant="outlined" fullWidth onClick={handleReset}>
            Reset
          </Button>
        </Grid>
      </Grid>
    </Card>
  );
}

export default Sidebar;
